import Icon from "@ant-design/icons";

const Svg = () => {
  return (
    <svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M26 13.0063C26 20.1679 20.1651 26 13 26C5.83494 26 0 20.1679 0 13.0063C0 5.83213 5.83494 0 13 0C20.1651 0 26 5.83213 26 13.0063Z" fill="rgba(255, 149, 0, 1)"/>
    <rect x="8" y="8" width="4" height="10" rx="2" fill="white"/>
    <rect x="14" y="8" width="4" height="10" rx="2" fill="white"/>
    </svg>
  )
}
export const MyIcon = (props: any) => <Icon component={Svg} {...props} />;